export default "__VITE_ASSET__Dh4RqOTl__"